import { DOCUMENT } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { BaseComponent } from '../../../../shared/utils/base.component';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { TimesheetService } from '../../../../services/timesheet.service';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DateWithDayOfWeekPipe } from '../../../../services/dateWithDayOfWeek';
import { ListService } from '../../../../shared/services/list.service';
import { TimesheetStaffDeniedReasonsComponent } from '../timesheet-staff-deniedreasons/timesheet-staff-deniedreasons.component';
import { TimesheetStaffErrorcodeComponent } from '../timesheet-staff-errorcode/timesheet-staff-errorcode.component';
import { ErrorAlertService } from '../../../../shared/services/error-alert.service';
import { CalendarModule } from 'primeng/calendar';
import { UserService } from '../../../../services/user.service';
import { environment } from '../../../../../environments/environment';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';
import { TimepickerComponent } from '../../../../shared/components/timepicker/timepicker.component';
import { DateTimeFormatterService } from '../../../../shared/utils/date-time-formatter.service';
import { TimesheetUnitsHandler } from './timesheet-units.handler';
import { EnrollmentDataService } from '../../../../services/enrollment-data.service';

@Component({
  selector: 'ppl-timesheets-add-entries',
  standalone: true,
  imports: [
    CommonModule,
    NgZorroModule,
    ButtonComponent,
    ReactiveFormsModule,
    NzDatePickerModule,
    FormsModule,
    TableModule,
    NzToolTipModule,
    DateWithDayOfWeekPipe,
    TimesheetStaffDeniedReasonsComponent,
    TimesheetStaffErrorcodeComponent,
    CalendarModule,
    DropdownSelectComponent,
    TimepickerComponent
  ],
  templateUrl: './timesheets-add-entries.component.html',
  providers: [TimesheetUnitsHandler],
  styleUrl: './timesheets-add-entries.component.css',
})
export class TimesheetNewEntriesComponent
  extends BaseComponent
  implements OnInit {
  pageId = '';
  addTimesheetForm!: FormGroup;
  showEntries = false;
  reasonList: LookupValueItem[] = [];
  programName!: string;
  @Input() entryType = 'timeEntry';
  @Input() payPeriod: any;
  @Input() consumers: any;
  @Input() action = 'add';
  @Input() timesheetData: any;
  @Input() entryPage: any;
  @Input() staffView = false;
  @Input() isReadOnly = false;
  @Output() timesheetAdded = new EventEmitter();
  @Output() onClose = new EventEmitter();
  rowStatus: boolean[] = [];
  serviceCodes: any;
  timesheetDates: string[] = [];
  additionalConsumers: any;
  statusList: LookupValueItem[] = [];
  processingStatusList: LookupValueItem[] = [];
  serviceCodesTO: any;
  codesForTwoConsumers = [182, 184, 186, 188, 195, 196, 199, 200, 201];
  enableApplicationStatus = ['S', 'SB', 'PE'];
  disableProcessingStatus = ['AI', 'AIA', 'AD', 'RV', 'VIA', 'VI', 'RI', 'VD', 'TPD', 'TBP'];
  serviceChanged: boolean[] = [];
  showFormFields = true;
  error: any;
  errors: any[] = [];
  fieldErrors: Record<number, Record<string, boolean>> = {};
  providerId: any;
  providerPPLId: any;
  isTwoConsumerSC = false;
  pplIdError = false;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('billedUnitsValidationDialog') billedUnitsValidationDialog!: TemplateRef<any>;
  @ViewChild('pendedDialog') pendedDialog!: TemplateRef<any>;
  @ViewChild('deniedDialog') deniedDialog!: TemplateRef<any>;
  @ViewChild('availableUnitsWarningDialog') availableUnitsWarningDialog!: TemplateRef<any>;
  @ViewChild('exceededUnitsConfirmationDialog') exceededUnitsConfirmationDialog!: TemplateRef<unknown>;
  totalBilledUnitsForWarning = 0;
  authUnitsExistsFormatted = '';
  totalEnteredTimeFormatted = '';
  exceedingTimeFormatted = '';
  errorcodeData: any;
  deniedData: any;
  isConsentRequired = false;
  isTimesheetDeleted = false;
  timeInTimeOutEqualMessage = 'Service Time In cannot be equal to Service Time Out.';
  timeOutLessThanTimeInMessage = 'Service Time In cannot be greater than Service Time Out.';
  timeOutOverNightShiftMessage = 'Overnight shifts must be entered separately after midnight (12:00 AM).';
  isExternal = false;
  isTimesheetLoaded: boolean = false;
  customErrors = [];
  isAuthFail = false;
  alertMessage: any[] = [];
  isHRStaff: any;
  isPA: any;
  isPaperTSProcessor: any;
  timesheetNotAllowedMessage = false;
  backDaysAllowedForTimesheet = 0;
  availableUnits: any;
  private billedUnitsCache = new Map<string, number | null>();
  private fixedOneUnits = [202];
  private readonly enableAuthCheckForAll = false;
  showAuthPopup = false;

  private dialogSvc = inject(DialogService);

  constructor(
    private fb: FormBuilder,
    private timesheetService: TimesheetService,
    private errorAlertService: ErrorAlertService,
    private listService: ListService,
    private dateTimeFormatterService: DateTimeFormatterService,
    private userService: UserService,
    private timesheetUnitsHandler: TimesheetUnitsHandler,
    private enrollmentService: EnrollmentDataService,
    @Inject(DOCUMENT) private doc: Document
  ) {
    super();
  }

  ngOnInit(): void {
    this.isExternal = environment.isExternal;
    this.addTimesheetForm = this.fb.group({
      consumer: [{ value: null, disabled: this.action === 'edit' }],
      period: [{ value: null, disabled: this.action === 'edit' }],
      timesheetEntries: this.fb.array([]),
      isAgreed: [false]
    });
    if (this.entryPage === 'timesheets') {
      this.addTimesheetForm.addControl('providerPplId', this.fb.control('PRV-NY-'));
      this.showFormFields = false;
    }

    if (this.staffView) {
      this.showFormFields = false;
      this.showEntries = true;
    }

    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';

    if (this.programName) {
      this.timesheetService.getTimesheetConfig(this.programName).subscribe({
        next: (res) => {
          const limit = res?.responsedata?.['timesheet.timely.filling.limit'];
          if (limit != null) {
            this.backDaysAllowedForTimesheet = Number(limit);
          }
        }
      });
    }

    const userDetails = this.userService.getUserDetails();
    if (!userDetails) {
      console.error('no user details found');
      return;
    }
    const { usertype_lkp } = userDetails;
    this.isHRStaff = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL HR Staff') && usertype_lkp === 'FMS';
    this.isPA = selectedProgram?.roles.some((role: any) => role.role_name === 'Employer (External)');
    this.isPaperTSProcessor = selectedProgram?.roles.some((role: any) => role.role_name === 'Paper Timesheet Processor');

    const allReasons = this.lookupService.getLookupValue('Manual Entry reason');
    this.reasonList = this.isPaperTSProcessor
      ? allReasons
      : allReasons.filter((item: LookupValueItem) => item.lkpValueCode !== 'R8' && item.lkpValueCode !== 'R9');
    this.statusList = this.lookupService.getLookupValue('Business Status');
    this.processingStatusList = this.lookupService.getLookupValue('TS_App_S');
    if (this.enableAuthCheckForAll) {
      this.showAuthPopup = true;
    } else {
      this.getPAAttributes();
    }
    if (this.action === 'edit') {
      const payPeriod = this.payPeriod?.find(
        (period: any) =>
          period.payrollId === this.timesheetData.payrollScheduleId
      );

      const [startDate, endDate] = payPeriod.payPeriod.split('-');
      const payload = {
        programCode: 'NY',
        consumerId: this.timesheetData.consumer.consumerId,
        periodFromDate: startDate,
        periodToDate: endDate,
        providerId: this.timesheetData.provider.providerId
      };
      this.timesheetService
        .getServiceCodesByConsumer(payload)
        .subscribe((data: any) => {
          if (data.status === 200) {
            this.alertMessage = data.responsedata || [];
          }
          if (data.responsedata == "Auth Fail" && data.status == 404) {
            this.isAuthFail = true;
            const date = this.payPeriod.find(
              (period: any) => period.payrollId === payPeriod?.payrollId
            );

            if (!date) {
              return;
            }

            this.timesheetEntries.clear();
            const [startDate, endDate] = date?.payPeriod.split('-') || [];
            const startDateObj = new Date(startDate);
            const endDateObj = new Date(endDate);

            this.addTimesheetForm.patchValue({
              consumer: this.timesheetData.consumer.consumerId,
              period: payPeriod?.payrollId,
              isAgreed: false
            });

            this.handleAuthFailErrors(data, startDateObj, endDateObj);
            return;
          }

          this.serviceCodes = data.responsedata;
          this.availableUnits = this.serviceCodes[0].authUnitsExists;
          this.authUnitsExistsFormatted = this.serviceCodes[0].authUnitsExistsFormatted ?? '';
          this.addTimesheetForm.patchValue({
            consumer: this.timesheetData.consumer.consumerId,
            period: payPeriod?.payrollId,
            isAgreed: false
          });

          if (this.staffView) {
            this.processTimesheetByServiceLinesForStaff();
          } else {
            if (
              this.serviceCodes === null ||
              this.serviceCodes === undefined ||
              this.serviceCodes?.length < 1
            ) {
              this.showEntries = false;
            } else {
              this.showEntries = true;
              const selectedPayId = this.addTimesheetForm.get('period')?.value;
              const date = this.payPeriod.find(
                (period: any) => period.payrollId === selectedPayId
              );

              if (!date) {
                return;
              }

              this.timesheetEntries.clear();
              const [startDate, endDate] = date?.payPeriod.split('-') || [];
              const startDateObj = new Date(startDate);
              const endDateObj = new Date(endDate);
              const allDatesInPeriod = this.getAllDatesInRange(startDateObj, endDateObj);
              const validDates = this.getValidDates(allDatesInPeriod, this.serviceCodes);
              console.log('valid dates', validDates);
              this.processTimesheet(validDates)
            }
          }
        });
    }
  }

  getConsumersAndPayPeriod() {
    const pplId = this.addTimesheetForm.get('providerPplId')?.value.trim();
    this.addTimesheetForm.get('consumer')?.setValue(null);
    console.log('providerpplid', pplId);
    this.providerPPLId = pplId;
    this.pplIdError = pplId === '';
    if (pplId !== '') {
      this.showFormFields = true;
      this.getConsumers(pplId);
      this.getPayPeriod();
    }
  }

  getPAAttributes(){
    const payload = {
      "programCode": this.programName,
      "providerId": this.userService.getSelectedLead()!,
      "attributeIds": [{ "attributeId": 147 }]
    };
    this.enrollmentService.getPAAttributes(payload).subscribe((data) => {
      this.showAuthPopup = data.responsedata?.['147'] === 'Yes';
    })
  }

  getConsumers(pplId: any) {
    const payload = {
      programCode: this.programName,
      providerId: null,
      providerPplId: pplId,
      consumerId: null,
      consumerPplId: null,
    };
    this.timesheetService
      .getConsumerListByPPLId(payload)
      .subscribe((data: any) => {
        this.consumers = this.isPA
          ? (data.responsedata.consumers ?? []).filter(
              (consumer: any) => consumer.associationStatus !== 'Disassociated'
            )
          : data.responsedata.consumers;
        this.providerId = data?.responsedata?.providers?.[0]?.providerId ?? null;
      });
  }

  getPayPeriod() {
    this.timesheetService
      .getPayPeriod(this.programName)
      .subscribe((data: any) => {
        this.payPeriod = data.responsedata;
      });
  }

  convertTimeStringToDate(timeString: string): Date {
    const currentDate = new Date();
    const [hours, minutes] = timeString.split(':');
    currentDate.setHours(Number(hours), Number(minutes), 0, 0); // Set the hours and minutes
    return currentDate;
  }

  get timesheetEntries() {
    return this.addTimesheetForm.get('timesheetEntries') as FormArray;
  }

  generateFormattedDatesFromRange(date: any): string[] {
    const [startDateStr, endDateStr] = date?.payPeriod.split('-') || [];
    const [startMonth, startDay, startYear] = startDateStr.split('/').map(Number);
    const [endMonth, endDay, endYear] = endDateStr.split('/').map(Number);

    const start = new Date(Date.UTC(startYear, startMonth - 1, startDay));
    const end = new Date(Date.UTC(endYear, endMonth - 1, endDay));

    const dates: string[] = [];
    const formatDate = (date: Date): string => {
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const year = date.getUTCFullYear();
      return `${month}/${day}/${year}`;
    };

    const current = new Date(start);
    while (current <= end) {
      dates.push(formatDate(current));
      current.setUTCDate(current.getUTCDate() + 1);
    }

    return dates;
  }

  isPredefinedRow(index: number): boolean {
    const entry = this.timesheetEntries.at(index);
    const serviceDate = entry.get('serviceDate')?.value;
    return this.timesheetDates.includes(serviceDate);
  }

  addTimesheetEntry(date: any): void {
    const today = new Date();
    const timeOffPastThreaholdDate = new Date();
    const timeOffFutureThreaholdDate = new Date();
    const timeEntryPastThreaholdDate = new Date();
    timeEntryPastThreaholdDate.setDate(new Date().getDate() - this.backDaysAllowedForTimesheet);
    timeEntryPastThreaholdDate.setHours(0, 0, 0, 0);
    timeOffPastThreaholdDate.setDate(new Date().getDate() - 15);
    timeOffFutureThreaholdDate.setDate(new Date().getDate() + 90);
    today.setHours(0, 0, 0, 0);
    const entryDate = new Date(date);
    entryDate.setHours(0, 0, 0, 0);
    const isFutureDate = (entryDate > today && (this.entryType === 'timeEntry' || this.entryType === '')) || (entryDate > timeOffFutureThreaholdDate && this.entryType === 'timeOff');
    const isBackDate = (entryDate < timeOffPastThreaholdDate && this.entryType === 'timeOff' && !this.isHRStaff) || (entryDate < timeEntryPastThreaholdDate && this.entryType === 'timeEntry' && this.isPA);
    const timesheetEntry = this.fb.group(
      {
        selected: [false],
        serviceDate: [date],
        timeSheetDetailId: [null],
        businessStatusLkp: [{ value: null, disabled: true }],
        applicationStatusLkp: [null],
        applicationStatusLkpCode: [null],
        service: [{ value: null, disabled: isFutureDate || isBackDate }],
        serviceTimeIn: [{ value: null, disabled: isFutureDate || isBackDate }],
        serviceTimeOut: [{ value: null, disabled: isFutureDate || isBackDate }],
        additionalConsumerId: [null],
        billedUnits: [{ value: null, disabled: true }],
        manualReasonLkp: [
          { value: null, disabled: isFutureDate || isBackDate },
        ],
        overrideService: [false]
      },
      { disabled: isFutureDate || isBackDate }
    );
    this.timesheetEntries.push(timesheetEntry);
    if (!isFutureDate && !isBackDate) {
      timesheetEntry.get('serviceTimeIn')?.valueChanges.subscribe(() => {
        this.updateTimesheetUnits(timesheetEntry);
      });

      timesheetEntry.get('serviceTimeOut')?.valueChanges.subscribe(() => {
        this.updateTimesheetUnits(timesheetEntry);
      });
    }
  }

  updateTimesheetUnits(entry: FormGroup): void {
    // Billed units are only recalculated while creating a timesheet or for editable lines;
    // existing/locked lines keep the billed units returned by the server.
    if (!this.isTimesheetLineEditable(entry)) {
      return;
    }

    const serviceTimeIn = entry.get('serviceTimeIn')?.value;
    const serviceTimeOut = entry.get('serviceTimeOut')?.value;
    const serviceCode = entry.get('service')?.value;

    if (!serviceCode || !serviceTimeIn || !serviceTimeOut) {
      entry.get('billedUnits')?.setValue(null);
      return;
    }

    const serviceDate = entry.get('serviceDate')?.value;
    const correctedTimeIn = this.overrideDateWithServiceDate(serviceTimeIn, serviceDate);
    const correctedTimeOut = this.overrideDateWithServiceDate(serviceTimeOut, serviceDate);

    if (correctedTimeOut < correctedTimeIn) {
      entry.get('billedUnits')?.setValue(null);
      return;
    }

    const shiftStart = this.dateTimeFormatterService.formatDate(correctedTimeIn, 'yyyy-MM-ddTHH:mm:ss');
    const shiftEnd = this.dateTimeFormatterService.formatDate(correctedTimeOut, 'yyyy-MM-ddTHH:mm:ss');

    if (this.entryType === 'timeOff') {
      const serviceCodeLkp = serviceCode.serviceCodeLkp;
      const serviceCodeDetailId = serviceCode.serviceCodeDetailId;
      const billedUnits = this.timesheetUnitsHandler.calculateBilledUnits(correctedTimeIn, correctedTimeOut, serviceCodeLkp, serviceCodeDetailId);
      entry.get('billedUnits')?.setValue(billedUnits);
      return;
    }

    const payload = {
      ServiceCode: serviceCode.serviceCodeLkp,
      Modifier: serviceCode.modifierCode,
      ShiftStart: shiftStart,
      ShiftEnd: shiftEnd,
    };
    const cacheKey = `${payload.ServiceCode}|${payload.Modifier}|${payload.ShiftStart}|${payload.ShiftEnd}`;
    if (this.billedUnitsCache.has(cacheKey)) {
      if (this.billedUnitsCache.get(cacheKey) !== -1) {
        entry.get('billedUnits')?.setValue(this.billedUnitsCache.get(cacheKey));
        this.checkTotalUnitsAgainstAvailable(serviceCode.serviceCodeDetailId);
      }
      return;
    }

    this.billedUnitsCache.set(cacheKey, -1); // Set to -1 to indicate that the value is being fetched
    this.timesheetService.getBilledUnits(this.programName, payload).subscribe((data: any) => {
      const billedUnits = data?.responsedata?.units ?? null;
      this.billedUnitsCache.set(cacheKey, billedUnits);
      entry.get('billedUnits')?.setValue(billedUnits);
      this.checkTotalUnitsAgainstAvailable(serviceCode.serviceCodeDetailId);
    });
  }

  private isTimesheetLineEditable(entry: FormGroup): boolean {
    if (this.isReadOnly || entry.disabled) {
      return false;
    }
    const timeIn = entry.get('serviceTimeIn');
    const timeOut = entry.get('serviceTimeOut');
    return !!timeIn?.enabled && !!timeOut?.enabled;
  }

  private checkTotalUnitsAgainstAvailable(serviceCodeDetailId: number): void {
    if (this.entryType === 'timeOff' || this.staffView || this.entryPage === 'timesheets' || !this.isPA || !this.showAuthPopup) return;

    const sc = (this.serviceCodes ?? []).find((s: { serviceCodeDetailId: number; authUnitsExistsFormatted?: string }) => s.serviceCodeDetailId === serviceCodeDetailId && s.authUnitsExistsFormatted);
    if (!sc) return;
    const availableMinutes = this.parseFormattedTimeToMinutes(sc.authUnitsExistsFormatted);
    const totalEnteredMinutes = this.getTotalEnteredMinutesForServiceCode(serviceCodeDetailId);

    if (totalEnteredMinutes > availableMinutes) {
      const exceedingMinutes = totalEnteredMinutes - availableMinutes;
      this.exceedingTimeFormatted = this.formatMinutes(Math.max(exceedingMinutes, 0));
      const dialogConfig: DialogConfig = {
        title: 'Warning',
        isOkText: 'Ok',
        size: 'medium',
        position: 'top',
        showClose: false,
        showButtons: false,
        showOkButton: true,
      };
      this.dialogSvc.openDialog(
        this.availableUnitsWarningDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
  }

  private getTotalEnteredMinutes(): number {
    let totalMinutes = 0;
    this.timesheetEntries.controls.forEach(entry => {
      const timeIn: Date | null = entry.get('serviceTimeIn')?.value;
      const timeOut: Date | null = entry.get('serviceTimeOut')?.value;
      if (timeIn && timeOut) {
        const inMinutes = timeIn.getHours() * 60 + timeIn.getMinutes();
        const outMinutes = timeOut.getHours() * 60 + timeOut.getMinutes();
        if (outMinutes > inMinutes) {
          totalMinutes += outMinutes - inMinutes;
        }
      }
    });
    return totalMinutes;
  }

  private getTotalEnteredMinutesForServiceCode(serviceCodeDetailId: number): number {
    let totalMinutes = 0;
    this.timesheetEntries.controls.forEach(entry => {
      const service = entry.get('service')?.value;
      if (service?.serviceCodeDetailId !== serviceCodeDetailId) return;
      const timeIn: Date | null = entry.get('serviceTimeIn')?.value;
      const timeOut: Date | null = entry.get('serviceTimeOut')?.value;
      if (timeIn && timeOut) {
        const inMinutes = timeIn.getHours() * 60 + timeIn.getMinutes();
        const outMinutes = timeOut.getHours() * 60 + timeOut.getMinutes();
        if (outMinutes > inMinutes) {
          totalMinutes += outMinutes - inMinutes;
        }
      }
    });
    return totalMinutes;
  }

  private parseFormattedTimeToMinutes(formatted: string): number {
    const hoursMatch = formatted.match(/(\d+)\s*hour/);
    const minutesMatch = formatted.match(/(\d+)\s*minute/);
    const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;
    return hours * 60 + minutes;
  }

  private formatMinutes(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} hour${hours !== 1 ? 's' : ''} and ${String(minutes).padStart(2, '0')} minutes`;
  }

  private overrideDateWithServiceDate(time: Date, serviceDate: string): Date {
    if (!serviceDate) return time;
    const date = new Date(serviceDate);
    const corrected = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), 0, 0);
    return corrected;
  }

  isAddDisabled(entry: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const entryDate = new Date(entry.get('serviceDate')?.value);
    const entryApplicationStatus = {
      applicationStatusLkp: entry.get('applicationStatusLkpCode')?.value
    };
    entryDate.setHours(0, 0, 0, 0);
    const timeEntryPastThreaholdDate = new Date();
    timeEntryPastThreaholdDate.setDate(new Date().getDate() - this.backDaysAllowedForTimesheet);
    timeEntryPastThreaholdDate.setHours(0, 0, 0, 0);
    const isFutureDate = entryDate > today && (this.entryType === 'timeEntry' || this.entryType === '');
    const isBackDate = (entryDate < today && this.entryType === 'timeOff') || (entryDate < timeEntryPastThreaholdDate && this.entryType === 'timeEntry' && this.isPA);
    return this.isAuthFail || isFutureDate || isBackDate || this.isTimesheetDisabled(entryApplicationStatus);
  }

  addTimeSlot(dateIndex: number): void {
    const entry = this.timesheetEntries.at(dateIndex) as FormGroup;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const entryDate = new Date(entry.get('serviceDate')?.value);
    entryDate.setHours(0, 0, 0, 0);
    const isFutureDate = entryDate > today && this.entryType === 'timeEntry';
    const isBackDate = entryDate < today && this.entryType === 'timeOff';
    const timesheetEntry = this.fb.group({
      selected: [true],
      serviceDate: [entry.get('serviceDate')?.value],
      service: [{ value: null, disabled: isFutureDate || isBackDate }],
      serviceTimeIn: [{ value: null, disabled: isFutureDate || isBackDate }],
      serviceTimeOut: [{ value: null, disabled: isFutureDate || isBackDate }],
      additionalConsumerId: [null],
      billedUnits: [{ value: null, disabled: true }],
      manualReasonLkp: [
        { value: null, disabled: isFutureDate || isBackDate },
      ],
      isNewRow: [true]
    });
    this.timesheetEntries.insert(dateIndex + 1, timesheetEntry);
    timesheetEntry.get('serviceTimeIn')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(timesheetEntry);
    });

    timesheetEntry.get('serviceTimeOut')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(timesheetEntry);
    });
  }


  duplicateRow(index: number): void {
    const entry = this.timesheetEntries.at(index) as FormGroup;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const entryDate = new Date(entry.get('serviceDate')?.value);
    entryDate.setHours(0, 0, 0, 0);
    const isFutureDate = entryDate > today && this.entryType === 'timeEntry';
    const isBackDate = entryDate < today && this.entryType === 'timeOff';
    const isOverrideTimesheet = entry.get('overrideService')?.value;
    const timesheetEntry = this.fb.group({
      selected: [true],
      serviceDate: [entry.get('serviceDate')?.value],
      service: isOverrideTimesheet ? [{ value: null, disabled: isFutureDate || isBackDate }] : [{ value: entry.get('service')?.value, disabled: isFutureDate || isBackDate }],
      serviceTimeIn: [{ value: entry.get('serviceTimeIn')?.value, disabled: isFutureDate || isBackDate }],
      serviceTimeOut: [{ value: entry.get('serviceTimeOut')?.value, disabled: isFutureDate || isBackDate }],
      additionalConsumerId: [entry.get('additionaonTimePickerOpenlConsumerId')?.value],
      billedUnits: [{ value: entry.get('billedUnits')?.value, disabled: true }],
      manualReasonLkp: [
        { value: entry.get('manualReasonLkp')?.value, disabled: isFutureDate || isBackDate },
      ],
      isNewRow: [true]
    });
    this.timesheetEntries.insert(index + 1, timesheetEntry);
    timesheetEntry.get('serviceTimeIn')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(timesheetEntry);
    });

    timesheetEntry.get('serviceTimeOut')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(timesheetEntry);
    });

  }

  deleteRow(index: number): void {
    console.log('delete clicked');
    this.timesheetEntries.removeAt(index);
  }

  formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = '00';

    return `${hours}:${minutes}:${seconds}`;
  }

  transformToServiceLines(input: any, action: string) {
    console.log('input receivwd', input);
    let serviceLines: any[] = [];

    input.forEach((entry: any) => {
      serviceLines.push({
        selected: entry.selected,
        serviceDate: entry.serviceDate || '',
        serviceTimeIn: entry.serviceTimeIn ? this.formatTime(new Date(entry.serviceTimeIn)) : null,
        serviceTimeOut: entry.serviceTimeOut ? this.formatTime(new Date(entry.serviceTimeOut)) : null,
        serviceCodeDetailId: entry.service?.serviceCodeDetailId,
        serviceCodeDescription: entry.service?.serviceModifierDescription,
        serviceCodeLkp: entry.service?.serviceCodeLkp,
        modifierCodeLkp: entry.service?.modifierCode,
        billedUnits: entry.billedUnits,
        availableUnits: this.availableUnits ?? null,
        manualReasonLkp: entry.manualReasonLkp,
        additionalConsumers: entry.additionalConsumerId,
        timeSheetDetailId: entry.timeSheetDetailId || 0,
        businessStatusLkp:
          this.statusList?.find(
            (status: any) => status.lkpValueName === entry.businessStatusLkp
          )?.lkpValueCode || null,
        applicationStatusLkpCode: entry.applicationStatusLkp,
        applicationStatusLkp:
          this.processingStatusList?.find(
            (status: any) => status.lkpValueName === entry.applicationStatusLkp
          )?.lkpValueCode || null,
      });
    });

    serviceLines = serviceLines.filter((e: any) => e.selected);

    return serviceLines;
  }

  createTimesheetPayload(data: any, action: string) {
    const period = this.payPeriod.find(
      (period: any) => period.payrollId === data.period
    );
    console.log('data in submit', data);
    const payload = {
      programCode: this.programName,
      action: action,
      provider: {
        providerId: this.staffView ? this.timesheetData?.provider?.providerId :
          this.entryPage === 'timesheets'
            ? this.providerId
            : this.userService.getSelectedLead()!,
      },
      consumer: this.staffView ? this.timesheetData.consumer : this.consumers.find(
        (consumer: any) => consumer.consumerId === data.consumer
      ),
      payrollScheduleId: period.payrollId,
      serviceLines: this.transformToServiceLines(data.timesheetEntries, action),
      source: this.entryPage === 'timesheets' ? "StaffView" : this.staffView ? null : "pa-add-time-entry",
    };
    return payload;
  }

  checkService(event: any, index: any) {
    this.serviceChanged[index] = true;
    if (this.codesForTwoConsumers.includes(event?.serviceCodeDetailId)) {
      this.rowStatus[index] = true;
    } else {
      this.rowStatus[index] = false;
    }
    this.updateTimesheetUnitsOnSC(index);
  }

  updateTimesheetUnitsOnSC(index: any) {
    const entry = this.timesheetEntries.at(index) as FormGroup;
    this.updateTimesheetUnits(entry);
  }

  onMoveBack() {
    const formData = this.addTimesheetForm.getRawValue();
    let timeEnties = formData.timesheetEntries
    let selectedTimeEntries = timeEnties.filter((e: any) => e.selected && (e.applicationStatusLkpCode == 'RP' || e.applicationStatusLkpCode == 'TP'));

    if (selectedTimeEntries.length == 0) {
      const errorMessage = `Please select the timesheets with a processing status of 'Ready for Payment'.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    const timesheetIds = selectedTimeEntries.map((e: any) => e.timeSheetDetailId);

    const payload = {
      timesheetIds: timesheetIds
    }

    this.timesheetService.moveBackTimesheet(this.programName, payload).subscribe((data: any) => {
      if (data.status === 200) {
        this.timesheetAdded.emit({ timesheetAdded: true });
      }
    });
  }

  evaluateLongShiftHoursAndSave(action: string) {
    let longShiftRecorded = false;
    this.timesheetEntries.controls.forEach((entryGroup: any, index: number) => {
      const isEntrySelected = entryGroup.get('selected')?.value ?? false;

      if (isEntrySelected) {
        const timeIn = entryGroup.get('serviceTimeIn')?.value;
        const timeOut = entryGroup.get('serviceTimeOut')?.value;

        const inTimeInMinutes = (timeIn.getHours() * 60) + (timeIn.getMinutes());
        const outTimeInMinutes = (timeOut.getHours() * 60) + (timeOut.getMinutes());
        const billedTime = outTimeInMinutes - inTimeInMinutes;
        if (billedTime > 780) {
          longShiftRecorded = true;
        }
      }
    });

    if (longShiftRecorded) {
      const dialogConfig: DialogConfig = {
        title: 'Confirmation',
        isOkText: 'Yes',
        size: 'medium',
        position: 'top',
        showClose: true,
        showButtons: true,
      };

      this.dialogSvc.openDialog(
        this.billedUnitsValidationDialog,
        dialogConfig,
        () => this.evaluateAvailableUnitsAndSave(action),
        () => this.handleCancel()
      );
    } else {
      this.evaluateAvailableUnitsAndSave(action);
    }
  }

  private evaluateAvailableUnitsAndSave(action: string): void {
    if (action === 'submit' && this.entryType !== 'timeOff' && !this.staffView && this.entryPage !== 'timesheets' && this.isPA && this.showAuthPopup) {
      const serviceCodesToCheck = (this.serviceCodes ?? []).filter((sc: { authUnitsExistsFormatted?: string }) => sc.authUnitsExistsFormatted);
    for (const sc of serviceCodesToCheck) {
      const availableMinutes = this.parseFormattedTimeToMinutes(sc.authUnitsExistsFormatted);
      const totalEnteredMinutes = this.getTotalEnteredMinutesForServiceCode(sc.serviceCodeDetailId);

      if (totalEnteredMinutes > availableMinutes) {
        this.totalBilledUnitsForWarning = totalEnteredMinutes;
        const dialogConfig: DialogConfig = {
          title: 'Warning',
          isOkText: 'Yes',
          cancelText: 'No',
          size: 'medium',
          position: 'top',
          showClose: false,
          showButtons: true,
        };
        this.dialogSvc.openDialog(
          this.exceededUnitsConfirmationDialog,
          dialogConfig,
          () => this.onSave(action),
          () => this.handleCancel()
        );
        return;
      }
      }
    }
    this.onSave(action);
  }

  onSave(action: string) {
    const payload = this.createTimesheetPayload(
      this.addTimesheetForm.getRawValue(),
      action
    );
    let isValid = true;
    this.fieldErrors = {};
    this.isConsentRequired = false;

    if (!this.addTimesheetForm.get('isAgreed')?.value) {
      isValid = false;
      this.isConsentRequired = true;
      const errorMessage = 'Please select the consent to save the timesheet.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (!payload.consumer) {
      isValid = false;
      const errorMessage = 'Please select the consumer to save the timesheet.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (this.isPA && ['In PPL Review', 'Returned'].includes(payload.consumer.associationStatus)) {
      isValid = false;
      const errorMessage = "You cannot clock in for this consumer because you are not eligible to work until all required paperwork and pre-employment screenings are complete, including the I-9 verification and health assessment. To resolve the outstanding items or find out what's still needed, please contact us at 1-833-247-5346. ";
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (this.entryPage === 'timesheets') {
      const pplId = this.addTimesheetForm.get('providerPplId')?.value.trim();
      if (this.providerPPLId != pplId) {
        isValid = false;
        const errorMessage = `Provider has been changed. Please click the 'Get Consumer' button to update the consumer details before saving.`;
        this.errorAlertService.openModal('error', 'Error', errorMessage);
        return;
      }
    }

    if (payload.serviceLines.length == 0) {
      isValid = false;
      const errorMessage = 'Please select the timesheets to save.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    let selectedTimeEntries = payload.serviceLines.filter((e: any) => e.selected && (e.applicationStatusLkp && e.applicationStatusLkp != 'S' && e.applicationStatusLkp != 'SB' && e.applicationStatusLkp != 'PE'));

    if (selectedTimeEntries.length) {
      const errorMessage = `Please select the timesheets with a processing status of 'Saved' or 'Submitted' only.`;
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    this.timesheetEntries.controls.forEach((entryGroup: any, index: number) => {
      const isEntrySelected = entryGroup.get('selected')?.value ?? false;

      if (isEntrySelected) {
        const service = entryGroup.get('service')?.value;
        const reason = entryGroup.get('manualReasonLkp')?.value;
        const timeIn = entryGroup.get('serviceTimeIn')?.value;
        const timeOut = entryGroup.get('serviceTimeOut')?.value;
        const billedUnits = entryGroup.get('billedUnits')?.value;
        const businessStatus = entryGroup.get('businessStatusLkp')?.value;

        const additionalConsumerId = entryGroup.get(
          'additionalConsumerId'
        )?.value;
        const fields = [
          { name: 'service', value: service },
          { name: 'serviceTimeIn', value: timeIn },
          { name: 'serviceTimeOut', value: timeOut },
          { name: 'billedUnits', value: billedUnits },
        ];

        const businessStatusCode = this.statusList?.find(
          (status: any) => status.lkpValueName === businessStatus
        )?.lkpValueCode;

        if (businessStatusCode !== "GP") {
          fields.push({ name: 'manualReasonLkp', value: reason });
        }

        if (
          this.codesForTwoConsumers.includes(service?.serviceCodeDetailId) &&
          this.serviceChanged[index]
        ) {
          fields.push({
            name: 'additionalConsumerId',
            value: additionalConsumerId,
          });
        }

        if (timeIn && timeOut && this.isTimeInAndTimeOutInvalid(index, new Date(timeIn), new Date(timeOut))) {
          isValid = false;
        }

        const filledFields = fields.filter(
          (field) => field.value != null && field.value !== ''
        );
        if (!this.fieldErrors[index]) {
          this.fieldErrors[index] = {};
        }

        fields.forEach((field) => {
          if (
            (!field.value && filledFields.length > 0) ||
            (field.name === 'billedUnits' && field.value < 0)
          ) {
            isValid = false;
            this.fieldErrors[index][field.name] = true;
          } else {
            if (this.fieldErrors[index][field.name]) {
              delete this.fieldErrors[index][field.name];
            }
          }
        });
      }
    });

    if (!isValid) {
      this.error = true;
    } else {
      this.error = false;
      this.timesheetService.saveTimesheet(payload, this.action).subscribe((data: any) => {
        if (data.status === 200) {
          this.timesheetAdded.emit({ timesheetAdded: true });
        }
      });
    }
  }

  isTimeInAndTimeOutInvalid(index: number, timeIn: Date, timeOut: Date) {
    const inHours = timeIn.getHours();
    const inMinutes = timeIn.getMinutes();
    const outHours = timeOut.getHours();
    const outMinutes = timeOut.getMinutes();

    const totalMinutesIn = inHours * 60 + inMinutes;
    const totalMinutesOut = outHours * 60 + outMinutes;

    if (totalMinutesIn === totalMinutesOut) {
      if (!this.fieldErrors[index]) {
        this.fieldErrors[index] = {};
      }
      this.fieldErrors[index]['timeInEqualTimeOut'] = true;

      return true;
    }

    if (totalMinutesOut < totalMinutesIn) {
      if (!this.fieldErrors[index]) {
        this.fieldErrors[index] = {};
      }
      if (outHours < 8 || (outHours === 0 && outMinutes === 0)) {
        this.fieldErrors[index]['timeInAfterTimeOutOverNightShift'] = true;
      } else {
        this.fieldErrors[index]['timeInAfterTimeOut'] = true;
      }

      return true;
    }

    return false;
  }

  isFieldEmpty(fieldName: string, index: number): boolean {
    return this.fieldErrors[index]?.[fieldName] ?? false;
  }

  isBilledUnitsNegative(index: number): boolean {
    return this.fieldErrors[index]?.['billedUnits'] ?? false;
  }

  groupByDate(serviceLines: any[]) {
    return serviceLines?.reduce((acc, entry) => {
      const date = entry.serviceDate;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(entry);
      return acc;
    }, {});
  }

  enableTimesheetForm(event: any) {
    console.log('Enabling', event);
    this.additionalConsumers = this.consumers?.filter((consumer: any) => {
      return (
        consumer.consumerId !== this.addTimesheetForm.getRawValue().consumer
      );
    });
    const selectedPayId = this.addTimesheetForm.get('period')?.value;
    const date = this.payPeriod.find(
      (period: any) => period.payrollId === selectedPayId
    );

    if (!date) {
      return;
    }

    this.timesheetEntries.clear();
    const [startDate, endDate] = date?.payPeriod.split('-') || [];
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(endDate);
    const providerId = this.userService.getSelectedLead()!
    const payload = {
      programCode: 'NY',
      consumerId: this.addTimesheetForm.getRawValue().consumer,
      periodFromDate: startDate,
      periodToDate: endDate,
      providerId: providerId
    };

    if (this.entryType === 'timeOff') {
      const selectedProgram = this.userService.getSelectedProgram();
      const userDetails = this.userService.getUserDetails();
      if (!userDetails) {
        console.error('no user details found');
        return;
      }
      const { usertype_lkp } = userDetails;
      const isHRStaff = selectedProgram?.roles.some((role: any) => role.role_name === 'PPL HR Staff') && usertype_lkp === 'FMS';
      if (date?.payPeriod) {
        const payload = {
          providerId: this.userService.getSelectedLead()!,
          fromDate: startDate,
          toDate: endDate,
          programCode: this.programName
        }
        this.timesheetService
          .getAllTimeoffServiceCodes(payload)
          .subscribe((data: any) => {
            if (data.status === 200) {
              this.serviceCodesTO = data.responsedata;
            }
            if (isHRStaff) {
              this.serviceCodesTO = data.responsedata;
            } else {
              this.serviceCodesTO = data.responsedata?.filter((e: any) => (e.code === 'PTO' || e.code === 'UPST'));
            }
            console.log('serviceCodes', this.serviceCodesTO);
            if (this.serviceCodesTO === null || this.serviceCodesTO === undefined || this.serviceCodesTO?.length < 1) {
              this.showEntries = false;
            } else {
              this.showEntries = true;
              const allDatesInPeriod = this.getAllDatesInRange(startDateObj, endDateObj);
              this.processTimesheet(allDatesInPeriod)
            }
          });
      }
      return;
    }

    if (this.action !== 'edit' && this.entryType !== 'timeOff') {
      if (this.addTimesheetForm.getRawValue().consumer && date?.payPeriod) {
        this.timesheetService
          .getServiceCodesByConsumer(payload)
          .subscribe((data: any) => {
            if (data.status === 200) {
              this.alertMessage = data.responsedata || [];
            }
            if (data.responsedata == "Auth Fail" && data.status == 404) {
              this.isAuthFail = true;
              this.handleAuthFailErrors(data, startDateObj, endDateObj);
              return;
            }

            this.serviceCodes = data.responsedata;
            console.log('serviceCodes', this.serviceCodes);
            this.availableUnits = this.serviceCodes[0].authUnitsExists;
            this.authUnitsExistsFormatted = this.serviceCodes[0].authUnitsExistsFormatted ?? '';

            if (
              this.serviceCodes === null ||
              this.serviceCodes === undefined ||
              this.serviceCodes?.length < 1
            ) {
              this.showEntries = false;
            } else {
              this.showEntries = true;
              const allDatesInPeriod = this.getAllDatesInRange(startDateObj, endDateObj);
              const validDates = this.getValidDates(allDatesInPeriod, this.serviceCodes);
              console.log('valid dates', validDates);
              this.processTimesheet(validDates)
            }
          });
      }
    } else {
      this.showEntries = true;
    }

    if (this.action !== 'add') {
      this.processTimesheet(date);
    }
  }

  handleAuthFailErrors(data: any, startDateObj: any, endDateObj: any) {
    this.customErrors = [];
    if (this.timesheetData?.serviceLines) {
      this.buildServiceCodesFromTimesheetLines();
      if (this.serviceCodes) {
        this.showEntries = true;
        const allDatesInPeriod = this.getAllDatesInRange(startDateObj, endDateObj);
        const validDates = this.getValidDates(allDatesInPeriod, this.serviceCodes);
        console.log('valid dates', validDates);
        this.processTimesheet(validDates)
        return;
      }
    }

    this.showEntries = false;
    this.customErrors = data.responsemsg.split(",");
    return;
  }

  buildServiceCodesFromTimesheetLines() {
    this.serviceCodes = [];

    this.timesheetData?.serviceLines.forEach((line: any) => {
      const existing = this.serviceCodes.find((item: any) =>
        item.modifierCode === line.modifierCodeLkp &&
        item.serviceCodeLkp === line.serviceCodeLkp
      );

      if (existing) {
        const lineDate = new Date(line.serviceDate);

        // Update fromDate to the earliest date
        if (new Date(existing.fromDate) > lineDate) {
          existing.fromDate = line.serviceDate;
        }

        // Update toDate to the latest date
        if (new Date(existing.toDate) < lineDate) {
          existing.toDate = line.serviceDate;
        }

      } else {
        this.serviceCodes.push({
          fromDate: line.serviceDate,
          modifierCode: line.modifierCodeLkp,
          serviceCodeDetailId: line.serviceCodeDetailId,
          serviceCodeLkp: line.serviceCodeLkp,
          serviceModifierDescription: line.serviceDescription ?? line.serviceCodeDescription,
          toDate: line.serviceDate,
        });
      }
    });
  }


  getAllDatesInRange(startDate: Date, endDate: Date): string[] {
    const dates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      dates.push(this.formatDate(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  }

  getValidDates(allDatesInPeriod: string[], serviceCodes: any[]): string[] {
    const validDatesSet = new Set<string>();

    allDatesInPeriod.forEach((date) => {
      serviceCodes.forEach((serviceCode: any) => {
        if (!serviceCode.fromDate && !serviceCode.toDate) {
          return;
        }
        const serviceFromDate = this.createDateInUTC(serviceCode.fromDate);
        const serviceToDate = this.createDateInUTC(serviceCode.toDate);

        if (new Date(date) >= serviceFromDate && new Date(date) <= serviceToDate) {
          validDatesSet.add(date);
        }
      });
    });

    return Array.from(validDatesSet);
  }

  createDateInUTC(dateString: string): Date {
    const [year, month, day] = dateString.split("-");
    const formattedDate = `${month}/${day}/${year}`;

    return new Date(formattedDate);
  }

  formatDate(date: Date): string {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  getFilteredServiceCodesForDate(entry: any): any[] {
    const date = entry.get('serviceDate')?.value;
    const overrideService = entry.get('overrideService')?.value;

    if (overrideService) {
      return [entry.get('service')?.value];
    }
    return this.serviceCodes?.filter((serviceCode: any) => {
      const serviceFromDate = this.createDateInUTC(serviceCode.fromDate);
      const serviceToDate = this.createDateInUTC(serviceCode.toDate);
      const selectedDate = new Date(date);

      return selectedDate >= serviceFromDate && selectedDate <= serviceToDate;
    });
  }

  getServiceCodesBasedOnEntryDate(entry: any): any[] {
    const date = entry.get('serviceDate')?.value;
    const transformedDate = new Date(date);
    const timeOffPastThresholdDate = new Date();
    timeOffPastThresholdDate.setDate(new Date().getDate() - 15);

    let filteredServiceCodes = this.serviceCodesTO;
    if (transformedDate < timeOffPastThresholdDate && !this.isHRStaff) {
      filteredServiceCodes = filteredServiceCodes?.filter(
        (serviceCode: any) => serviceCode.code !== 'PTO'
      );
    }
    return filteredServiceCodes?.filter((serviceCode: any) => {
      if (!serviceCode.fromDate && !serviceCode.toDate) {
        return true;
      }
      else {
        const serviceFromDate = this.createDateInUTC(serviceCode.fromDate);
        const serviceToDate = this.createDateInUTC(serviceCode.toDate);
        if (!serviceFromDate || !serviceToDate) {
          return false;
        }
        return transformedDate >= serviceFromDate && transformedDate <= serviceToDate;
      }
    });
  }

  processTimesheet(date: any) {
    if (this.entryType === 'timeOff') {
      this.timesheetDates = date;
    }
    else {
      if (this.isAuthFail || (this.entryType === 'timeEntry' && date && date.length > 0)) {
        this.timesheetDates = date;
      } else {
        this.timesheetDates = this.generateFormattedDatesFromRange(date);
      }
    }
    console.log('dates list', this.timesheetDates);
    if (this.entryType === 'timeEntry' && this.timesheetDates?.length) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const sixtyDaysAgo = new Date();
      sixtyDaysAgo.setDate(today.getDate() - this.backDaysAllowedForTimesheet);
      sixtyDaysAgo.setHours(0, 0, 0, 0);
      this.timesheetNotAllowedMessage = this.timesheetDates.some((serviceDateStr: string) => {
        const serviceDate = new Date(serviceDateStr);
        serviceDate.setHours(0, 0, 0, 0);
        return serviceDate < sixtyDaysAgo;
      });
    }
    this.timesheetDates?.forEach((serviceDate: any) => {
      if (this.action !== 'edit') {
        this.addTimesheetEntry(serviceDate);
      } else {
        this.processTimesheetByServiceLines(serviceDate);
      }
    });

    this.timesheetEntries?.controls?.forEach((formGroup, index) => {
      let previousValues = { ...formGroup.value };
      formGroup.valueChanges.subscribe((newValue) => {
        Object.keys(newValue).forEach(controlName => {
          const oldValue = previousValues[controlName];
          const currentValue = newValue[controlName];
          if (oldValue !== currentValue && controlName !== 'selected') {
            formGroup.get('selected')?.setValue(true, { emitEvent: false });
          }
        });
        previousValues = { ...newValue };
      });
    });
  }

  processTimesheetByServiceLines(serviceDate: any) {
    const groupedServiceLines = this.groupByDate(
      this.timesheetData?.serviceLines
    );
    const linesForDate = groupedServiceLines[serviceDate] || [];
    if (linesForDate.length > 0) {
      linesForDate.forEach((line: any) => {
        this.addTimesheetEntry(serviceDate);
        this.patchTSValuesForLine(line);
      });
    } else {
      this.addTimesheetEntry(serviceDate);
    }
  }

  processTimesheetByServiceLinesForStaff() {
    const groupedServiceLines = this.groupByDate(
      this.timesheetData?.serviceLines
    );

    if (this.entryType === 'timeEntry' && groupedServiceLines) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const sixtyDaysAgo = new Date();
      sixtyDaysAgo.setDate(today.getDate() - this.backDaysAllowedForTimesheet);
      sixtyDaysAgo.setHours(0, 0, 0, 0);
      const allServices = Object.values(groupedServiceLines).flat();
      this.timesheetNotAllowedMessage = allServices.some((service: any) => {
        const serviceDate = new Date(service.serviceDate);
        serviceDate.setHours(0, 0, 0, 0);
        return serviceDate < sixtyDaysAgo;
      });
    }
    for (const [date, lines] of Object.entries(groupedServiceLines)) {
      const records: any = lines;
      records.forEach((line: any) => {
        this.addTimesheetEntry(date);
        this.patchTSValuesForLine(line);
      });
    }

    this.timesheetEntries.controls.forEach((formGroup, index) => {
      let previousValues = { ...formGroup.value };
      formGroup.valueChanges.subscribe((newValue) => {
        Object.keys(newValue).forEach(controlName => {
          const oldValue = previousValues[controlName];
          const currentValue = newValue[controlName];
          if (oldValue !== currentValue && controlName !== 'selected') {
            formGroup.get('selected')?.setValue(true, { emitEvent: false });
          }
        });
        previousValues = { ...newValue };
      });
    });
  }

  isTimesheetDisabled(entryData: any): boolean {
    return this.disableProcessingStatus.indexOf(entryData.applicationStatusLkp) > -1;
  }

  patchTSValuesForLine(entryData: any) {
    const entryGroup = this.timesheetEntries.at(
      this.timesheetEntries.length - 1
    );
    let selectedService = this.serviceCodes?.find(
      (service: any) =>
        service.serviceCodeDetailId === entryData.serviceCodeDetailId
    );

    let disableTimesheet = false;
    if (!selectedService) {
      disableTimesheet = true;
      selectedService = {
        fromDate: entryData.serviceDate,
        modifierCode: entryData.modifierCodeLkp,
        serviceCodeDetailId: entryData.serviceCodeDetailId,
        serviceCodeLkp: entryData.serviceCodeLkp,
        serviceModifierDescription: entryData.serviceDescription ?? entryData.serviceCodeDescription,
        toDate: entryData.serviceDate,
      };
    }

    let finalServiceCodes = this.serviceCodes?.filter((serviceCode: any) => {
      const serviceFromDate = this.createDateInUTC(serviceCode.fromDate);
      const serviceToDate = this.createDateInUTC(serviceCode.toDate);
      const selectedDate = new Date(entryData.serviceDate);

      return selectedDate >= serviceFromDate && selectedDate <= serviceToDate;
    });

    let hasInFinalServiceCodes = finalServiceCodes.find((c: any) => c.serviceCodeDetailId == selectedService.serviceCodeDetailId);
    if (!disableTimesheet && !hasInFinalServiceCodes) {
      disableTimesheet = true;
    }
    entryGroup?.patchValue({
      selected: false,
      timeSheetDetailId: entryData.timeSheetDetailId,
      businessStatusLkp: this.getLookupValue(
        this.statusList,
        entryData.businessStatusLkp
      ),
      applicationStatusLkp: this.getLookupValue(
        this.processingStatusList,
        entryData.applicationStatusLkp
      ),
      applicationStatusLkpCode: entryData.applicationStatusLkp,
      service: selectedService,
      serviceTimeIn: entryData.serviceTimeIn ? this.convertTimeStringToDate(entryData.serviceTimeIn) : null,
      serviceTimeOut: entryData.serviceTimeOut ? this.convertTimeStringToDate(entryData.serviceTimeOut) : null,
      billedUnits: entryData.billedUnits,
      manualReasonLkp: entryData.manualReasonLkp,
      overrideService: disableTimesheet
    }, { emitEvent: false });

    if (
      !this.enableApplicationStatus.includes(entryData.applicationStatusLkp) || this.codesForTwoConsumers.includes(entryData.serviceCodeDetailId)
    ) {
      const formGroup = entryGroup as FormGroup;
      Object.keys(formGroup.controls).forEach(controlName => {
        if (controlName != 'selected') {
          const control = formGroup.get(controlName);
          if (control) {
            control.disable();
          }
        }
      });
    }

    if (disableTimesheet || this.isTimesheetDisabled(entryData)) {
      const formGroup = entryGroup as FormGroup;
      Object.keys(formGroup.controls).forEach(controlName => {
        const control = formGroup.get(controlName);
        if (control) {
          control.disable();
        }
      });
    }
  }

  translateTimeOffRows(input: any) {
    console.log('input receivwd', input);
    let timesheetLines: any[] = [];

    input.forEach((entry: any) => {
      if (entry.serviceTimeIn && entry.serviceTimeOut) {
        timesheetLines.push({
          serviceDate: entry.serviceDate || '',
          serviceTimeIn: this.formatTime(new Date(entry.serviceTimeIn)),
          serviceTimeOut: this.formatTime(new Date(entry.serviceTimeOut)),
          serviceCodeLkp: entry.service?.code,
          serviceCodeDetailId: entry.service?.serviceCodeDetailId,
          billedUnits: entry.billedUnits,
          selected: entry.selected
        });
      }
    });

    timesheetLines = timesheetLines.filter((e: any) => e.selected);

    return timesheetLines;
  }

  createTimeOffPayload() {
    const formData = this.addTimesheetForm.getRawValue();
    const payroll = this.payPeriod.filter(
      (period: any) => period.payrollId === formData.period
    );
    const [startDate, endDate] = payroll[0].payPeriod.split('-');
    return {
      programCode: this.programName,
      provider: {
        providerId: this.userService.getSelectedLead()!,
      },
      payrollScheduleId: payroll[0].payrollId,
      payPeriodStartDate: startDate,
      payPeriodEndDate: endDate,
      timesheetLines: this.translateTimeOffRows(formData.timesheetEntries),
    };
  }

  get isSaveDisabled(): boolean {
    const isAnyEntryFilled = this.timesheetEntries.controls.some(
      (entryGroup) => {
        const service = entryGroup.get('service')?.value;
        const reason = entryGroup.get('manualReasonLkp')?.value;
        const serviceTimeIn = entryGroup.get('serviceTimeIn')?.value;
        const serviceTimeOut = entryGroup.get('serviceTimeOut')?.value;
        const billedUnits = entryGroup.get('billedUnits')?.value;
        return (
          service || reason || serviceTimeIn || serviceTimeOut || billedUnits
        );
      }
    );
    return this.isAuthFail || !isAnyEntryFilled;
  }

  openConfirmationPopup(index: number) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Yes',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteTimesheet(index),
      () => this.handleCancel()
    );
  }

  handleCancel() {

  }

  saveTimeOff() {
    const payload = this.createTimeOffPayload();
    let isValid = true;
    this.fieldErrors = {};


    this.isConsentRequired = false;

    if (!this.addTimesheetForm.get('isAgreed')?.value) {
      isValid = false;
      this.isConsentRequired = true;
      const errorMessage = 'Please select the consent to save the time off.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    if (payload.timesheetLines.length == 0) {
      const errorMessage = 'Please select the time off to save.';
      this.errorAlertService.openModal('error', 'Error', errorMessage);
      return;
    }

    this.timesheetEntries.controls.forEach((entryGroup: any, index: number) => {
      const service = entryGroup.get('service')?.value;
      const timeIn = entryGroup.get('serviceTimeIn')?.value;
      const timeOut = entryGroup.get('serviceTimeOut')?.value;
      const billedUnits = entryGroup.get('billedUnits')?.value;
      const fields = [
        { name: 'service', value: service },
        { name: 'serviceTimeIn', value: timeIn },
        { name: 'serviceTimeOut', value: timeOut },
        { name: 'billedUnits', value: billedUnits },
      ];

      const filledFields = fields.filter(
        (field) => field.value != null && field.value !== ''
      );
      if (!this.fieldErrors[index]) {
        this.fieldErrors[index] = {};
      }

      fields.forEach((field) => {
        if (
          (!field.value && filledFields.length > 0) ||
          (field.name === 'billedUnits' && field.value < 0)
        ) {
          isValid = false;
          this.fieldErrors[index][field.name] = true;
        } else {
          if (this.fieldErrors[index][field.name]) {
            delete this.fieldErrors[index][field.name];
          }
        }
      });
    });

    if (!isValid) {
      this.error = true;
    } else {
      this.error = false;
      this.timesheetService.saveTimeOff(payload).subscribe((data: any) => {
        if (data.status === 200) {
          this.timesheetAdded.emit({ timesheetAdded: true });
        }
      });
    }
  }

  deleteTimesheet(index: number): void {
    const entry = this.timesheetEntries.at(index) as FormGroup;
    const serviceDate = entry.get('serviceDate')?.value;
    const id = entry.value.timeSheetDetailId;
    const otherEntries = this.timesheetEntries.controls.filter((entry, i) =>
      i !== index && entry.get('serviceDate')?.value === serviceDate
    );

    const deleteTimesheetsPayload = { programCode: this.programName, timesheetLineDetailIds: [id] };

    this.timesheetService.deleteTimesheet(deleteTimesheetsPayload)
      .subscribe((response: any) => {
        if (response.status === 200) {
          if (otherEntries.length > 0) {
            this.timesheetEntries.removeAt(index);
          } else {
            this.timesheetEntries.removeAt(index);
            this.addEmptyRowAtIndex(serviceDate, index);
          }
          this.isTimesheetDeleted = true;
        } else {
          console.error('Error deleting timesheet:', response);
        }
      });
  }

  addEmptyRowAtIndex(serviceDate: string, index: number): void {
    const newEntry = this.fb.group({
      serviceDate: [serviceDate],
      service: [null],
      serviceTimeIn: [null],
      serviceTimeOut: [null],
      billedUnits: [{ value: null, disabled: true }],
      manualReasonLkp: [null],
      businessStatusLkp: [null],
      applicationStatusLkp: [null],
      applicationStatusLkpCode: [null],
      timeSheetDetailId: [null],
      selected: [false]
    });
    this.timesheetEntries.insert(index, newEntry);

    newEntry.get('serviceTimeIn')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(newEntry);
    });

    newEntry.get('serviceTimeOut')?.valueChanges.subscribe(() => {
      this.updateTimesheetUnits(newEntry);
    });

    this.timesheetEntries.controls.forEach((formGroup, index) => {
      const formGroupValueChanges = formGroup?.valueChanges as EventEmitter<any>;
      if (!formGroupValueChanges?.observed) {
        let previousValues = { ...formGroup.value };
        formGroup.valueChanges.subscribe((newValue) => {
          Object.keys(newValue).forEach(controlName => {
            const oldValue = previousValues[controlName];
            const currentValue = newValue[controlName];
            if (oldValue !== currentValue && controlName !== 'selected') {
              formGroup.get('selected')?.setValue(true, { emitEvent: false });
            }
          });
          previousValues = { ...newValue };
        });
      }
    });
  }

  openPendedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Pended Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.pendedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  openDeniedDialog() {
    const dialogConfig: DialogConfig = {
      title: `Denied Timesheet`,
      isOkText: 'Ok',
      size: 'x-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogSvc.openDialog(
      this.deniedDialog,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  handlePendedTimesheet(timeSheetDetailId: any) {
    console.log("timesheetLineId", timeSheetDetailId);
    const filters: any = [
      {
        jsonPath: "timesheetId",
        value: timeSheetDetailId,
        operator: "Equal"
      }
    ];
    const errorListPayload = this.buildRequestPayload(
      'timesheet-processCode',
      filters
    );
    this.listService
      .getListData(errorListPayload, 'claims')
      .subscribe((data: any) => {
        this.errorcodeData = data.responsedata;
        this.openPendedDialog();
      });
  }

  rowClickedTs(status: any, timeSheetDetailId: any) {
    if (status === 'Pended') {
      this.handlePendedTimesheet(timeSheetDetailId);
    }
    else if (status === 'Denied') {
      const payload = {
        pageName: 'timesheet-processCode',
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: 1,
        searchParam: [
          {
            jsonPath: 'timesheetId',
            value: timeSheetDetailId,
            operator: 'Equal',
          },
        ],
        orderByColumn: ['id'],
        orderBy: ['desc'],
      };
      this.listService
        .getListData(payload, 'claims')
        .subscribe((data: any) => {
          this.deniedData = data.responsedata;
          this.openDeniedDialog();
        });
    }
  }

  buildRequestPayload(pageName: string, searchParams: []) {
    if (searchParams.length == 0) {
      //handle the error here
      return;
    }

    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: '1',
      searchParam: searchParams,
      orderByColumn: [],
      orderBy: ['desc'],
    };
    return payload;
  }

  onCancel() {
    this.onClose.emit({ isTimesheetDeleted: this.isTimesheetDeleted });
  }

  public calculateTimeDifference(timeIn: Date | null, timeOut: Date | null): number | null {
    if (!timeIn || !timeOut) return null;
    const timeInDate = new Date(timeIn.setSeconds(0, 0));
    const timeOutDate = new Date(timeOut.setSeconds(0, 0));
    const diffInMs = timeOutDate.getTime() - timeInDate.getTime();
    return diffInMs / (1000 * 60); // return difference in minutes
  }
}
